import React, { useState } from 'react'

import { FormItem } from '@react/react-spectrum/Form'
import Heading from '@react/react-spectrum/Heading'
import NumberInput from '@react/react-spectrum/NumberInput'
import Switch from '@react/react-spectrum/Switch'
import { Tab, TabList } from '@react/react-spectrum/TabList'

import ColorInput from 'components/ColorInput'
import MediaUpload from 'components/MediaUpload'

import './MobileV2BrandingForm.scss'

export default function MobileV2BrandingForm({ branding, project, disabled, onChange }) {
  const [isAdvanced, setIsAdvanced] = useState(branding.variant === 'advanced')
  const onColorThemingChange = (v) => {
    setIsAdvanced(v)
    onChange('variant')(v ? 'advanced' : 'simple')
  }

  return (
    <>
      <section>
        <Heading size='4'>Logo</Heading>

        <MediaUpload
          type='image'
          value={branding.logo}
          heading='Drag and Drop'
          onUpload={onChange('logo')}
          projectId={project?.meta?.id}
          path={'branding-logo'}
          withTextfield={true}
          disabled={disabled}
        />
        <Heading size='4'>Logo (dark mode)</Heading>

        <MediaUpload
          type='image'
          value={branding.dark_logo}
          heading='Drag and Drop'
          onUpload={onChange('dark_logo')}
          projectId={project?.meta?.id}
          path={'branding-logo-dark'}
          withTextfield={true}
          disabled={disabled}
        />

        <Heading size='4'>Properties</Heading>
        <div className='mobile-v2-branding-form__properties'>
          <FormItem label='Logo width'>
            <NumberInput
              placeholder='Leave blank for auto'
              name='logoWidth'
              value={branding.logoWidth}
              onChange={onChange('logoWidth')}
              disabled={disabled}
            />
          </FormItem>
          <FormItem label='Border radius'>
            <NumberInput
              placeholder='Border radius'
              name='roundness'
              value={branding.roundness || 0}
              onChange={onChange('roundness')}
              disabled={disabled}
            />
          </FormItem>
        </div>
      </section>
      <section>
        <Heading size='4'>Colors</Heading>
        <Switch label='Advanced color theming' checked={isAdvanced} onChange={onColorThemingChange} />
        {isAdvanced ? (
          <AdvancedColorsForm branding={branding} disabled={disabled} onChange={onChange} />
        ) : (
          <SimpleColorsForm branding={branding} disabled={disabled} onChange={onChange} />
        )}
      </section>
    </>
  )
}

function SimpleColorsForm({ branding, disabled, onChange }) {
  return (
    <>
      <FormItem label={`Primary (required)`}>
        <ColorInput
          placeholder='Primary'
          name='primaryColor'
          value={branding.primaryColor}
          onChange={onChange('primaryColor')}
          disabled={disabled}
        />
      </FormItem>
    </>
  )
}

function AdvancedColorsForm({ branding, disabled, onChange }) {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)
  const renderColorInput = ({ label, name, isRequired }) => (
    <FormItem label={label + (isRequired ? ' (required)' : '')} key={label}>
      <ColorInput
        placeholder={isRequired ? label : 'Inherit'}
        name={name}
        value={branding[name]}
        onChange={onChange(name)}
        disabled={disabled}
        required={isRequired}
      />
    </FormItem>
  )

  return (
    <>
      <TabList onChange={setSelectedTabIndex}>
        <Tab>Light mode</Tab>
        <Tab>Dark mode</Tab>
      </TabList>
      <div>
        {selectedTabIndex === 0
          ? advancedColorsInputs.map(renderColorInput)
          : darkModeAdvancedColorsInputs.map(renderColorInput)}
      </div>
    </>
  )
}

const advancedColorsInputs = [
  { label: 'Primary', name: 'primaryColor', isRequired: true },
  { label: 'Secondary', name: 'secondaryColor' },
  { label: 'Tertiary', name: 'tertiaryColor' },
  { label: 'Background', name: 'backgroundColor' },
  { label: 'Text', name: 'textColor' },
  { label: 'Top bar background', name: 'topBarBackgroundColor' },
  { label: 'Top bar text', name: 'topBarTextColor' },
  { label: 'Top bar accent', name: 'topBarAccentColor' },
  { label: 'Bottom bar background', name: 'bottomBarBackgroundColor' },
  { label: 'Bottom bar text', name: 'bottomBarTextColor' },
  { label: 'Bottom bar accent', name: 'bottomBarAccentColor' },
]
const darkModeAdvancedColorsInputs = advancedColorsInputs.map(({ label, name }) => ({
  label: `${label} (dark)`,
  name: `dark_${name}`,
  isRequired: false,
}))
